module.exports = "pegasus_template/assets/tech/update/100.png";